export default "__VITE_ASSET__dd7b31ca__"